var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs"},_vm._l((_vm.path),function(item,i){return _c('breadcrumb-item',{key:("link-" + i),attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }